import { VelvetCommonContent } from "../../../../modules/content/components/VelvetCommonContent/VelvetCommonContent";
import { VelvetRichText } from "../../../../modules/content/components/VelvetRichText/VelvetRichText";
import { VelvetSection } from "../../../../modules/content/components/VelvetSection/VelvetSection";
import type { IWysiwygBlockProps } from "./WysiwygBlock.props";

export const WysiwygBlock = ({
  alignment,
  anchorId,
  buttons,
  content,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: IWysiwygBlockProps) => {
  if (!content) return null;

  return (
    <VelvetSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="grid gap-16 lg:grid-cols-12 lg:gap-y-24">
        <VelvetCommonContent
          alignment={alignment}
          buttons={buttons}
          className="lg:col-span-9"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <VelvetRichText
          className="max-w-[70ch] border-t border-parchment/50 pt-10 lg:col-span-8 lg:col-start-5 [&_h2]:mt-16 [&_h2]:font-velvet-display [&_h2]:text-4xl [&_h2]:font-black [&_h2]:uppercase [&_h2]:leading-[0.9] [&_h2]:tracking-[-0.035em] [&_h2:first-child]:mt-0"
          content={content}
        />
      </div>
    </VelvetSection>
  );
};

WysiwygBlock.displayName = "Block::WysiwygBlock";
